import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import router from './router';
import store from './store';


// var TWEEN = require("@tweenjs/tween.js");

import 'bulma/css/bulma.css';

// import "bulma/sass/bulma.sass";

Vue.use(VueAnalytics, {
  id: 'UA-38567004-3',
  router,
});

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

// The data.avlpark.com socket is retired (Oct 2026): start polling the S3 feeds on load.
store.commit('SOCKET_CONNECT', 'no-socket');
